export default __webpack_public_path__ + "static/cambodia-kep-cycling2-843d9ba713ab90b6e8d68cfad2f0a8a0.jpg";